<script>
   /*************************************************************/
   /* ModelInfo                                                 */
   /* -------------------------                                 */
   /* shows preprocessing model information                     */
   /*************************************************************/

   import { ButtonCancel, Container } from 'svelte-controls-basic';
   import PrepInfo from '../PrepInfo.svelte'

   let { model, reset } = $props();    // object with model



</script>

{#if model }
   <Container name="info">
      <p class="info-text">
         <span class="title">Preprocessing model</span><br>
         {#if model.fileName}
            <span>file:</span> <span title={model.fileName} class="file-name">{model.fileName}</span><br>
         {/if}
         {model.npred} <span>variables</span>,  <PrepInfo prepmodel={model} />
      </p>
      {#if reset}
      <ButtonCancel onclick={reset} />
      {/if}
   </Container>
{/if}

<style>
   .info-text {
      line-height: 1.5em;
   }

   .info-text > .title {
      display: inline-block;
      font-weight: bold;
      padding-bottom: 0.25em;
   }

   .info-text > :global(span) {
      vertical-align:top;
      color: #a0a0a0;
   }

   .info-text > .file-name {
      display: inline-block;
      padding: 0;
      margin: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 25ch;
      color: #222;
   }

</style>